import { PropsWithChildren, useState } from 'react';

import { createSafeContext } from 'core/Utils';

type MapContext = {
  id: string;
  mapArea: { lat: number; lng: number };
  setMapArea: (value: { lat: number; lng: number }) => void;
};

const [MapContextProvider, useMapContext_] = createSafeContext<MapContext>(
  'Map Context component was not found in tree'
);

interface MapProviderProps extends PropsWithChildren {
  /**
   * The ID of the map, this is used to identify the map when using multiple maps
   */
  id: string;
  latlng?: { lat: number; lng: number };
}

/**
 * Map Context Provider
 * This is used to provide the map context to the map
 * @returns
 */
const MapProvider = ({ id, children }: MapProviderProps) => {
  const [mapArea, setMapArea] = useState({ lat: 0, lng: 0 });
  return (
    <MapContextProvider value={{ id: id, mapArea, setMapArea }}>{children}</MapContextProvider>
  );
};

export { useMapContext_ as _useMapContext, MapProvider };
